/**
 * Commercial header — mobile menu sheet.
 *
 * Follows the theme's vanilla custom-element pattern (see assets/global.js).
 * No framework, no imports.
 */
class CommercialHeader extends HTMLElement {
  constructor() {
    super();
    this.toggle = this.querySelector('[data-menu-toggle]');
    this.menu = this.querySelector('[data-menu]');
    this.mq = window.matchMedia('(max-width: 989px)');
  }

  connectedCallback() {
    if (!this.toggle || !this.menu) return;

    this.onToggle = this.onToggle.bind(this);
    this.onKeydown = this.onKeydown.bind(this);
    this.onBreakpoint = this.onBreakpoint.bind(this);

    this.toggle.addEventListener('click', this.onToggle);
    document.addEventListener('keydown', this.onKeydown);
    this.mq.addEventListener('change', this.onBreakpoint);

    // Closing on navigation matters: the sheet is fixed, so a same-page anchor
    // would otherwise leave it covering the target.
    this.menu.addEventListener('click', (event) => {
      if (event.target.closest('a')) this.close();
    });
  }

  disconnectedCallback() {
    document.removeEventListener('keydown', this.onKeydown);
    this.mq.removeEventListener('change', this.onBreakpoint);
  }

  get isOpen() {
    return this.toggle.getAttribute('aria-expanded') === 'true';
  }

  onToggle() {
    this.isOpen ? this.close() : this.open();
  }

  onKeydown(event) {
    if (event.key === 'Escape' && this.isOpen) {
      this.close();
      this.toggle.focus();
    }
  }

  onBreakpoint(event) {
    if (!event.matches) this.close();
  }

  open() {
    this.toggle.setAttribute('aria-expanded', 'true');
    this.menu.classList.add('is-open');
    document.body.classList.add('c-menu-open');
  }

  close() {
    this.toggle.setAttribute('aria-expanded', 'false');
    this.menu.classList.remove('is-open');
    document.body.classList.remove('c-menu-open');
  }
}

if (!customElements.get('commercial-header')) {
  customElements.define('commercial-header', CommercialHeader);
}
